export const NAV_LINKS = [
  { label: 'Services', id: 'services' },
  { label: 'Benefits', id: 'benefits' },
  { label: 'Industries', id: 'industries' },
  { label: 'Case Studies', id: 'case-studies' },
  { label: 'ROI Calculator', id: 'roi-calculator' },
  { label: 'About', id: 'about' },
];

export const SERVICES = [
  {
    icon: 'server',
    title: 'Managed IT Services',
    desc: 'Reliable day-to-day IT operations so your team can focus on the business, not the break-fix cycle.',
    items: [
      'IT Operations Management',
      'Infrastructure Monitoring',
      'Security & Compliance',
      'Cloud Management',
    ],
  },
  {
    icon: 'robot',
    title: 'Business Process Automation',
    desc: 'Automate repetitive work with intelligent, connected systems that scale with your growth.',
    items: [
      'Workflow Automation',
      'Robotic Process Automation (RPA)',
      'AI-Powered Automation',
      'Integration Services',
      'Data Automation',
    ],
  },
  {
    icon: 'compass',
    title: 'Digital Transformation Consulting',
    desc: 'A clear technology roadmap to modernize legacy systems and future-proof operations.',
    items: [
      'Technology Roadmaps',
      'Modernization Strategies',
      'Platform Migration',
      'Cloud Adoption',
      'Process Optimization',
    ],
  },
  {
    icon: 'funnel',
    title: 'Go-To-Market Enablement',
    desc: 'Align sales, marketing, and revenue operations with technology built to accelerate growth.',
    items: [
      'Sales Process Automation',
      'CRM Optimization',
      'Marketing Automation',
      'Customer Journey Enhancement',
      'Revenue Operations',
    ],
  },
];

export const BENEFITS = [
  {
    icon: 'trending-up',
    tag: '+45%',
    title: 'Increase Productivity',
    desc: 'Eliminate repetitive tasks and empower teams to focus on strategic initiatives.',
  },
  {
    icon: 'dollar-sign',
    tag: '-30%',
    title: 'Reduce Costs',
    desc: 'Optimize operations and lower infrastructure and labor expenses.',
  },
  {
    icon: 'rocket',
    tag: '2x',
    title: 'Accelerate Growth',
    desc: 'Deploy scalable technology solutions that support rapid business expansion.',
  },
  {
    icon: 'gauge',
    tag: '+60%',
    title: 'Improve Efficiency',
    desc: 'Streamline workflows and eliminate operational bottlenecks.',
  },
  {
    icon: 'award',
    tag: '5x ROI',
    title: 'Increase ROI',
    desc: 'Deliver measurable business outcomes and technology investments that drive value.',
  },
];

export const WHY_CHOOSE_US = [
  { icon: 'award', title: 'Industry Expertise', desc: 'Deep experience across SMB, enterprise, and regulated industries.' },
  { icon: 'layers', title: 'Proven Methodologies', desc: 'Structured frameworks that de-risk technology transformation.' },
  { icon: 'shield-check', title: 'Certified Technology Consultants', desc: 'Credentialed experts across leading cloud and platform ecosystems.' },
  // { icon: 'robot', title: 'Automation Specialists', desc: 'Dedicated RPA & AI automation practitioners, not generalists.' },
  { icon: 'cpu', title: 'Scalable Solutions', desc: 'Architecture designed to grow with your business, not against it.' },
  { icon: 'target', title: 'Measurable Results', desc: 'Every engagement is tied to clear KPIs and ROI benchmarks.' },
  { icon: 'headset', title: 'Dedicated Client Support', desc: 'A responsive team invested in your long-term success.' },
];

export const INDUSTRIES = [
  { icon: 'shopping-cart', title: 'Retail', desc: 'Omnichannel systems, POS integration, and demand automation.' },
  { icon: 'cpu', title: 'Technology', desc: 'Scalable infrastructure and DevOps for fast-moving product teams.' },
  { icon: 'factory', title: 'Manufacturing', desc: 'Plant-floor to ERP automation and supply chain visibility.' },
  { icon: 'heart', title: 'Healthcare', desc: 'Secure, compliant systems that improve patient experience.' },
  // { icon: 'bank', title: 'Financial Services', desc: 'Risk-aware modernization with airtight compliance controls.' },
  // { icon: 'truck', title: 'Logistics', desc: 'Real-time tracking, routing automation, and fleet efficiency.' },
  // { icon: 'briefcase', title: 'Professional Services', desc: 'Client operations, billing, and knowledge workflows streamlined.' },
];

export const CASE_STUDIES = [
  {
    icon: 'trending-down',
    metric: '35%',
    label: 'Operational Cost Reduction',
    title: 'Manufacturing workflow automation',
    text: 'Redesigned procurement and inventory workflows with RPA, eliminating manual data entry across three facilities.',
  },
  // {
  //   icon: 'rocket',
  //   metric: '60%',
  //   label: 'Faster Customer Onboarding',
  //   title: 'Financial services onboarding overhaul',
  //   text: 'Automated document intake, KYC checks, and CRM handoffs to compress a multi-week onboarding process.',
  // },
  {
    icon: 'rocket',
    metric: '60%',
    label: 'Reporting That Shows Trend',
    title: 'Retail dashboards with your own data',
    text: 'Automated document and data intake, that displays your data in a sensible way, helps predictive analysis.',
  },
  {
    icon: 'clock',
    metric: '70%',
    label: 'Faster IT Response Times',
    title: 'Managed IT & help desk modernization',
    text: 'Deployed proactive monitoring and a tiered support model, cutting resolution time across a 500+ user org.',
  },
];

export const TESTIMONIALS = [
  {
    quote: 'Buildstrust rebuilt our IT operations from the ground up. Our downtime dropped to nearly zero and our team finally has bandwidth to innovate.',
    name: 'Sarah Mitchell',
    role: 'COO, Meridian Health Group',
  },
  {
    quote: 'The automation program paid for itself within four months. We reduced manual processing hours by more than half.',
    name: 'Anshuman',
    role: 'VP Operations, Foundry Constructions',
  },
  {
    quote: 'Their team feels like an extension of ours — strategic, responsive, and always tied to measurable business outcomes.',
    name: 'Priya Anand',
    role: 'CEO, Lattice Retail Co.',
  },
];

export const PARTNERS = [
  'Microsoft', 'AWS', 'Azure', 'Oracle', 'Google Cloud',
  'BMC', 'IBM', 'ServiceNow', 'Twilio', 'Power Platform',
];

export const CLOUD_PLATFORMS = [
  'Amazon Web Services (AWS)', 'Microsoft Azure', 'Oracle Cloud Infrastructure (OCI)', 'Google Cloud Platform (GCP)',
];

export const SERVICE_OPTIONS = [
  'Managed IT Services',
  'Business Process Automation',
  'Digital Transformation Consulting',
  'Go-To-Market Enablement',
  'Other / Not Sure',
];